import React from "react";
import axios from "axios";
import GlobalOpportunities from "../components/Recruitment/GlobalOpportunities";
import EmigrantsCards from "../components/Recruitment/EmigrantsCards";
import IndustriesWeCater from "../components/Recruitment/IndustriesWeCater";
import FAQSection from "../components/Recruitment/FAQSection";
import DeploymentProcessSection from "../components/Recruitment/DeploymentProcessSection";
import JobCards from "../components/JobsPage/JobCards";
import ContactSection from "../components/ContactSection";
import DownloadBrochure from "../components/JobsPage/DownloadBrochure";
import SecurityAndPartners from "../components/SecurityAndPartners";
import { API_CONFIG } from "../config/apiConfig";

const Recruitment = () => {
  const [pageData, setPageData] = React.useState<any>(null);
  const [loading, setLoading] = React.useState(true);
  const [filters, setFilters] = React.useState<{ country: string; category: string }>({
    country: "",
    category: "",
  });

  React.useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`${API_CONFIG.BASE_URL}/recruitment-page`, {
          headers: API_CONFIG.HEADERS,
        });
        const result = response.data;
        if (result?.status === "success" || result?.success) {
          setPageData(result.data);
        }
      } catch (error) {
        console.error("Error fetching recruitment page data:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  if (loading) {
    return <div className="min-h-[60vh] flex items-center justify-center font-poppins text-[#0d213b]">Loading...</div>;
  }

  return (
    <main>
      <GlobalOpportunities onApplyFilters={setFilters} data={pageData?.hero} />
      <JobCards filters={filters} sectionData={pageData?.jobs_section} />
      {/* <RecruitmentOverseasSection /> */}
      <EmigrantsCards data={pageData?.info_cards} />
      <IndustriesWeCater data={pageData?.industries} />
      <DeploymentProcessSection data={pageData?.deployment_process} />
      <SecurityAndPartners/>
      <FAQSection data={pageData?.faq} />
      {/* <ServicesContactpage /> */}
      <DownloadBrochure data={pageData?.brochure} />
       <ContactSection/>
    </main>
  );
};

export default Recruitment;

